import type { OutputData } from '@editorjs/editorjs';

import type { IncompleteEvent } from '../../../../types/DirectusSchema';
import { parseEventDetails } from './parseEventDetails.ts';
import { parseTargetAudiences } from './parseTargetAudiences.ts';

export const parseIncompleteEvent = (incompleteEvent: IncompleteEvent) => {
  return {
    ...incompleteEvent,
    target_audiences: parseTargetAudiences(incompleteEvent.target_audiences) ?? null,
    event_details: parseEventDetails(incompleteEvent.event_details) ?? null,
    venue: typeof incompleteEvent.venue === 'object' ? incompleteEvent.venue : null,
    category: typeof incompleteEvent.category === 'object' ? incompleteEvent.category : null,
    image: typeof incompleteEvent.image === 'string' ? incompleteEvent.image : null,
    description:
      typeof incompleteEvent.description === 'object' ? (incompleteEvent.description as unknown as OutputData) : null,
  };
};
